import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import {
  CatalogAction,
  DashboardAction,
  UserAction,
} from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";

class CatalogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "active"

      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      userId: "",
      isAllow: "",
      isAllowBasemix: false,
      isAllowAdditive: false,
      isAllowCategories: false,
      key: "1"
    };
  }
  componentDidMount() {
    const { getProducts, getBasemixProducts,
      getAdditiveProducts,
      getCategoriesProducts, keyTab } = this.props;

    const companyId = this.props.user?.[1]?.platform_owner?.id;

    if (keyTab == '1') {
      if (companyId) {
        getProducts(this.state.filter, true);
      }
      return

    }
    if (keyTab == '2') {
      getBasemixProducts({ ...this.state.filter })
      this.setState({ isAllowBasemix: true })
      return
    }
    if (keyTab == '3') {
      getAdditiveProducts({ ...this.state.filter });
      this.setState({ isAllowAdditive: true })
      return
    }
    if (keyTab == '4') {
      getCategoriesProducts({ ...this.state.filter });
      this.setState({ isAllowCategories: true })
      return
    }


  }
  componentDidUpdate(preProps, preState) {
    const {
      getProducts,
      getBasemixProducts,
      getAdditiveProducts,
      getCategoriesProducts,
    } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search ||
      preState.filter.status !== this.state.filter.status
    ) {
      !!this.state.isAllowBasemix
        ? getBasemixProducts(this.state.filter)
        : !!this.state.isAllowAdditive
          ? getAdditiveProducts(this.state.filter)
          : !!this.state.isAllowCategories
            ? getCategoriesProducts(this.state.filter)
            : getProducts(this.state.filter, true);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
    });
  };

  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  onChangeTab = (key) => {
    const {
      getProducts,
      getBasemixProducts,
      getAdditiveProducts,
      getCategoriesProducts,
      getTabProductKey
    } = this.props;
    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          search: "",
          status: "active"
        },
        isAllowAdditive: false,
        isAllowBasemix: false,
        isAllowCategories: false,
        isClose: false,
        key
      });
      getTabProductKey("1")
      getProducts({ ...this.state.filter }, true);
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          search: "",
        },
        isAllowBasemix: true,
        isAllowCategories: false,
        isAllowAdditive: false,
        isClose: false,
        key
      });
      getTabProductKey("2")
      getBasemixProducts({ ...this.state.filter });
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          search: "",
        },
        isAllowAdditive: true,
        isAllowBasemix: false,
        isAllowCategories: false,
        isClose: false,
        key
      });
      getTabProductKey("3")
      getAdditiveProducts({ ...this.state.filter });
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          search: "",
        },
        isAllowCategories: true,
        isAllowAdditive: false,
        isAllowBasemix: false,
        isClose: false,
        key
      });
      getTabProductKey("4")
      getCategoriesProducts({ ...this.state.filter });
    }
  };

  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };

  onChangeCatalog = () => { };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenModal &&
      this.props.delteCatalogProduct(this.state.userId, "deactivate", () => {
        this.props.getProducts(this.state.filter, true);
        this.toggleModal();
      });
  };
  render() {
    const { isOpenModal, isOpenLogisticModal, key } = this.state;
    const { products } = this.props;

    const additivesColumn = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>{r?.name}</span>
            </div>
          );
        },
      },

      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            <span
              style={{ color: "#26a69a", paddingRight: "5px" }}
              onClick={() =>
                this.props.history.push({
                  pathname: `/additives/${r.id}/update`,
                  state: { ...r, activeKey: "3 " },
                })
              }
              className="pointer-cursor"
            >
              {"EDIT"}
            </span>
          </div>
        ),
      },
    ];

    const categoriesColumn = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>{r?.name}</span>
            </div>
          );
        },
      },

      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            {!r.status && (
              <>
                <span
                  style={{ color: "#26a69a", paddingRight: "5px" }}
                  onClick={() =>
                    this.props.history.push({
                      pathname: `/categories/${r.id}/update`,
                      state: { ...r, activeKey: "4" },
                    })
                  }
                  className="pointer-cursor"
                >
                  EDIT
                </span>
              </>
            )}
          </div>
        ),
      },
    ];
    const basemixColumn = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>{r?.name}</span>
            </div>
          );
        },
      },
      {
        title: "DESCRIPTION",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            <span style={{ color: "#474747" }}>
              {r?.description === "" ? "-" : r?.description}
            </span>
          </div>
        ),
      },
      {
        title: "CATEGORY",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>
                {r?.basemix_category?.name}
              </span>
            </div>
          );
        },
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            {(!r.status || r.status) && (
              <>
                <span
                  style={{ color: "#26a69a", paddingRight: "5px" }}
                  onClick={() =>
                    this.props.history.push({
                      pathname: `/basemix/${r.id}/update`,
                      state: { ...r, activeKey: "2 " },
                    })
                  }
                  className="pointer-cursor"
                >
                  {"EDIT"}
                </span>
              </>
            )}
          </div>
        ),
      },
    ];

    const columns = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>{r?.name}</span>
            </div>
          );
        },
      },
      {
        title: "BASEMIX",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            <span style={{ color: "#474747" }}>{r?.basemix?.name}</span>
          </div>
        ),
      },
      {
        title: "ADDITIVE",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            {(r?.additives || []).map((item, index) => {
              return (
                <span style={{ color: "#474747" }}>
                  {`${!item.name ? "-" : item?.name}`}
                  {/* For Applying , in Every Map Iteration */}
                  {index < r?.additives.length - 1 ? ", " : ""}
                </span>
              );
            })}
          </div>
        ),
      },
      {
        title: "CATEGORY",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "20%",
        className: "action-class",

        render: (r) => {
          return (
            <div>
              <span style={{ color: "#474747" }}>{r?.category?.name}</span>
            </div>
          );
        },
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",

        render: (r) => (
          <div>
            {r.status && (
              <>
                <span
                  style={{ color: "#26a69a", paddingRight: "5px" }}
                  onClick={() =>
                    this.props.history.push({
                      pathname: `/product/${r.id}/update`,
                      state: { ...r, activeKey: "1 " },
                    })
                  }
                  className="pointer-cursor onhover"
                >
                  {"EDIT"}
                </span>
                <span
                  style={{ color: "red" }}
                  onClick={() => {
                    this.setState({
                      isOpenModal: !this.state.isOpenModal,
                      userId: r.id,
                    });
                  }}
                  className="pointer-cursor onhover"
                >
                  {"DELETE"}
                </span>
              </>
            )}
          </div>
        ),
      },

    ];
    console.log('PROPS_LOCATION==>', this.props.getTabProductKey)

    return (
      <Row justify="space-between">
        <Col span={24} style={{ marginTop: '-10px' }}>
          <PlantOrder
            {...this.props}
            inputText={"Manage Catalog"}
            onChangeTab={this.onChangeTab}
            onChangeCatalog={
              !!this.state.isAllowBasemix
                ? "/basemix/new"
                : !!this.state.isAllowAdditive
                  ? "/additives/new"
                  : !!this.state.isAllowCategories
                    ? "/categories/new"
                    : "/product/new"
            }
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeText={this.onChangeText}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
            columns={
              !!this.state.isAllowBasemix
                ? basemixColumn
                : !!this.state.isAllowAdditive
                  ? additivesColumn
                  : !!this.state.isAllowCategories
                    ? categoriesColumn
                    : columns
            }
            isShowProducts={true}
            activeKey={this.props?.keyTab || key}
            getTabProductKey={this.props.getTabProductKey}
          />
        </Col>
        <CustomModal
          visible={isOpenModal || isOpenLogisticModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Row justify="center">
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.handleModal()}
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col xl={24} className="d-flex justify-content-center">
              <img src={DeleteOrder} />
            </Col>
            <Col>
              <p>{"Are you sure you want to delete this product?"}</p>
            </Col>
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    products: store.CatalogReducer.products,
    user: store.AuthReducer.user,
    metaData: store.CatalogReducer.metaData,
    isLoader: store.CatalogReducer.isLodading,
    keyTab: store.CatalogReducer.keyTab
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    getBasemixProducts: (params) =>
      dispatch(CatalogAction.getBasemixProductReq(params)),
    getAdditiveProducts: (params) =>
      dispatch(CatalogAction.getAdditiveProductReq(params)),
    getCategoriesProducts: (params) =>
      dispatch(CatalogAction.getCategoriesProductReq(params)),
    plantActivation: (id, cb, params) =>
      dispatch(DashboardAction.plantActivationReq(id, cb, params)),
    delteCatalogProduct: (id, payload, cb) =>
      dispatch(CatalogAction.delteCatalogProductReq(id, payload, cb)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    getTabProductKey: (id) => dispatch(CatalogAction.getTabProductKeyReq(id))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CatalogContainer);
